import React from "react";
import { Modal } from "antd";
import { paymentStatus } from "../options";
import { convertTimeStamp } from "utility/functions/convertTimestamp";

const DetailModal = ({ isModalOpen, handleCancel, record }) => {
  return (
    <Modal
      title="票券詳情"
      open={isModalOpen}
      onCancel={handleCancel}
      footer={null}
    >
      <h6 className="bg-black text-white p-3 rounded-md my-2">
        {record.status !== 4 &&
          paymentStatus.find((item) => item.value === record.status)?.label}
      </h6>
      <p>活動名稱：{record.activityTitle}</p>
      <p>參加人/Name：{record.name}</p>
      <p>票號/Ticket Number：{record.id}</p>
      <p>票價/Price：{record.price}</p>
      <p>座位/Seat：自由選位</p>
      <p>票種/Ticket Type：{record.title}</p>
      <p>
        時間/Time：
        {`${convertTimeStamp(
          record.startDateTime,
          "MM/DD ddd - HH:mm"
        )}（opens at ${convertTimeStamp(
          record.admissionStartDateTime,
          "HH:mm"
        )}）`}
      </p>
      <p>
        有效時間/Available：
        {convertTimeStamp(record.admissionStartDateTime, "MM/DD ddd - HH:mm")}
        &nbsp; - &nbsp;
        {convertTimeStamp(record.admissionEndDateTime, "MM/DD ddd - HH:mm")}
      </p>
      <p>
        活動地點/Location：
        <a href={record.locationUrl}>
          {record.location}
          {record.locationTitle !== "undefined" && `(${record.locationTitle})`}
        </a>
      </p>

      {record?.status === 4 && (
        <>
          <p className="mt-6 mb-3">
            入場QR Code
            <img
              src={`data:image/jpeg;base64,${record.qrCode}`}
              className="w-1/4"
              alt="QRCode"
            />
          </p>
          <p>字軌：{record.taxSerialNumber}</p>
          <p>
            內容代徵娛樂稅 <br></br>
            本娛樂票券經{record.issuer}
            核准使用，並已向演出地之稅捐稽徵申請報繳娛樂稅
          </p>
        </>
      )}
    </Modal>
  );
};

export default DetailModal;
